import './src/global';
import './src/smoothscroll';
import './src/scroll-top';
import './src/blocks/hero-cover';